import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PRM } from '@reflact/prmacweb';
import { RatingService } from '../../observer-view/rating-scale/rating.service';
import { PackService } from '../services/PackService';
import { PdfAnnotationService } from '../services/PdfAnnotationService';

interface ParticipantSummary {
  events: Array<PRM.Event>;
  ratingSummary: RatingSummary;
  totalRating: RatingTotal;
  docannotations: any
  pack: PRM.IpadPackage
}

interface RatingSummary {
  dimensions: Array<any>;
  scale: Array<PRM.ScaleEntry>;
  ratings: Array<any>;
}

interface RatingTotal {
  devmeasures: string;
  learningArea: string;
  strength: string;
}

export const participantSummaryNewResolver: ResolveFn<ParticipantSummary> = async (route) => {
  const packService = inject(PackService);
  const ratingService = inject(RatingService);
  const pageAnnotationService = inject(PdfAnnotationService);
  const participantId = route.params.participantid;
  const totalRating: any = await ratingService.fetchObservationFormTotal(participantId);
  const docannotations = await pageAnnotationService.getDocAnnotations(route.params.participantid);
  const pack = await packService.getCurrentPackage();
  const participantSummary: ParticipantSummary = {
    events: [],
    ratingSummary: { dimensions: [], scale: [], ratings: [] },
    totalRating,
    docannotations,
    pack
  };
  const results: any = await ratingService.fetchModeratorRating(participantId);
  participantSummary.ratingSummary.ratings = results.dimensionresults;

  participantSummary.pack.eventdays.forEach((eventDay: PRM.EventDay) => {
    eventDay.events.forEach((event: PRM.Event) => {
      const result = parseEvent(event, participantId, ratingService);
      if (result) participantSummary.events.push(result);
    });
  });

  participantSummary.ratingSummary.dimensions.push(...participantSummary.pack.dimensions);
  participantSummary.ratingSummary.scale.push(...participantSummary.pack.scale);
  return participantSummary;
};

const parseEvent = (event: PRM.Event, participantId: string, ratingService: RatingService) => {
  if (event.participantId.indexOf(participantId) > -1 && event._id !== 'null' && event.timeblock.type === 'exercise') {
    event.participantSummaryDocuments = [];
    if (event.documents != null) {
      parseEventDocuments(event, event.documents);
    }
    if (event.timeblock.documents != null) {
      parseTimeBlockDocuments(event, event.timeblock.documents);
    }
    parseObservationForm(event, participantId, ratingService);
    return event;
  }
}

const parseObservationForm = async (event: PRM.Event, participantId: string, ratingService: RatingService) => {
  event.strengths = [];
  event.developmentAreas = [];
  event.notes = [];

  const result: any = await ratingService.fetchObervationFormResult(event.timeblock._id, participantId);
  if (result.strength && result.strength !== '') {
    event.strengths.push(result.strength);
  }
  if (result.learningArea && result.learningArea !== '') {
    event.developmentAreas.push(result.learningArea);
  }
  if (result.notes && result.notes !== '') {
    event.notes.push(result.notes);
  }
}

const parseTimeBlockDocuments = (event: PRM.Event, documents: Array<PRM.IpadDocument>) => {
  documents.forEach((document: PRM.IpadDocument) => {
    if (document.metadata.editable &&
      document.metadata.participantInstanceEnabled &&
      event.participantSummaryDocuments.findIndex(d => (d._id === document._id)) === -1) {
      event.participantSummaryDocuments.push(document);
    }
  });
}

const parseEventDocuments = (event: PRM.Event, documents: Array<PRM.IpadDocument>) => {
  documents.forEach((document: PRM.IpadDocument) => {
    if (document.metadata.editable &&
      document.metadata.participantInstanceEnabled &&
      event.participantSummaryDocuments.findIndex(d => (d._id === document._id)) === -1) {
      event.participantSummaryDocuments.push(document);
    }
  });
}